export const en = {
    "k_af37c0bd": "Organizational structure",
    "k_bdd1c828": "Search user",
    "k_91d0087a": "Filtration",
    "k_c2a35dfb": "Obtain user",
    "k_de7a4c8b": "User ID",
    "k_665bd9ee": "Please go to the role to manage this permission so that role members can obtain permission",
    "k_a0b1dbea": "Determine whether a user belongs to a certain role",
    "k_a51eb04f": "Determine whether the current user belongs to a certain role, such as: w.isRoleMemberOf(\"role-id\")",
    "k_67e74c27": "Role ID(for example,`\"role-id\"`)",
    "k_f77e6774": "Approval status",
    "k_4ddd757b": "Hook failed"
};
